
// HBJ Inventory Counter - Client-side injector
(function() {
  'use strict';
  
  function injectInventoryCounter() {
    // Get the metafield value from the product data
    const productJson = document.querySelector('script[type="application/json"][data-product-json]');
    if (!productJson) return;
    
    try {
      const productData = JSON.parse(productJson.textContent);
      const metafields = productData.metafields || [];
      
      // Find hbj_master_inventory metafield
      let available = null;
      for (const mf of metafields) {
        if (mf.namespace === 'custom' && mf.key === 'hbj_master_inventory') {
          available = parseInt(mf.value);
          break;
        }
      }
      
      if (available === null) return;
      
      const max_inventory = 13;
      const percent = (available / max_inventory) * 100;
      
      // Create inventory bar HTML
      let html = `
        <style>
          .hbj-inventory-bar {
            margin: 20px 0;
          }
          .inventory-label {
            display: flex;
            justify-content: space-between;
            margin-bottom: 8px;
            font-size: 12px;
            text-transform: uppercase;
          }
          .available-count {
            font-weight: 600;
            color: #0A0908;
          }
          .availability-text {
            color: #C4A870;
            font-weight: 500;
          }
          .progress-bar {
            width: 100%;
            height: 6px;
            background: #E8E0D0;
            border: 1px solid #3A3428;
            margin-bottom: 8px;
          }
          .progress-fill {
            height: 100%;
            background: #C4A870;
            transition: width 0.3s ease;
          }
          .waitlist-prompt {
            font-size: 13px;
            color: #0A0908;
            margin: 12px 0 0 0;
            font-style: italic;
          }
        </style>
        
        <div class="hbj-inventory-bar">
          <div class="inventory-label">
            <span class="available-count">${available}/${max_inventory}</span>
            <span class="availability-text">
              ${available > 8 ? 'In Stock' : available > 4 ? 'Low Stock' : available > 0 ? 'Very Limited' : 'Sold Out'}
            </span>
          </div>
          
          <div class="progress-bar">
            <div class="progress-fill" style="width: ${percent}%"></div>
          </div>
          
          ${available === 0 ? '<p class="waitlist-prompt">Join the waitlist for the next Limited Release drop.</p>' : ''}
        </div>
      `;
      
      // Find insertion point - after buy buttons, before description
      const buyButtons = document.querySelector('[data-section-type="main-product"] .product-form');
      if (buyButtons) {
        const container = document.createElement('div');
        container.innerHTML = html;
        buyButtons.parentNode.insertBefore(container, buyButtons.nextSibling);
      }
    } catch (e) {
      console.error('HBJ Inventory injection failed:', e);
    }
  }
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectInventoryCounter);
  } else {
    injectInventoryCounter();
  }
})();
